import React from 'react';
import { useState } from 'react';
import { AppBar, UserMenu, Confirm, useGetIdentity, useNotify, useLogout  } from 'react-admin';
import { ListItemIcon, MenuItem, useMediaQuery } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import logo from '../images/logo.svg';
import classnames from 'classnames';
import * as Constants from '../constants';

const useStyles = makeStyles(
    (theme) => ({
        menuItem: {
            color: theme.palette.text.secondary,
        },
        icon: { minWidth: theme.spacing(5) },
    }),
    { name: 'RaLogout' }
);


const styles = {
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    spacer: {
        flex: 1,
    },
    removeUser:{
        color: 'orange',
    }
};

  const RemoveUserWithRef = React.forwardRef(function Logout(props, ref) {
    const {
        className,
        classes: classesOverride,
        redirectTo,
        icon,
        userId,
        userFullName,
        userEmail,
        userToken,
        ...rest
    } = props;
    const classes = useStyles(props);
    const isXSmall = useMediaQuery((theme) =>
        theme.breakpoints.down('xs')
    );
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);

    const notify = useNotify();
    const logout = useLogout();
    const [isLoadingDeleteUser, setIsLoadingDeleteUser] = useState(false);
    const [open, setOpen] = useState(false);
    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {
        const request = new Request(`${Constants.siteUrl}/users/delete_user/`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json', 
            'Authorization': `Bearer ${userToken}` }),
        });
        setIsLoadingDeleteUser(true)
        fetch(request).then((param) => {
            if (param.status != 200){
                notify(`Failed to delete user, please try again`, { type: 'error' });
                setIsLoadingDeleteUser(false);
            }
            else{
                setIsLoadingDeleteUser(false);
                setOpenDeleteConfirm(true);
            }                        
        }).catch(error => {
            notify(`Failed to delete user, please try again`, { type: 'error' });
            setIsLoadingDeleteUser(false);
        });
        setOpen(false);
    };
    return (
        <>
        <MenuItem
            className={classnames('logout', classes.menuItem, className)} 
            onClick={handleClick}
            ref={ref}
            component={isXSmall ? 'span' : 'li'}
        >
            <ListItemIcon className={classes.icon}>
            <HighlightOffIcon fontSize="medium" style={{ color: 'orange' }}/>
            </ListItemIcon>
            Remove User
        </MenuItem>
        <Confirm
        isOpen={open}
        loading={isLoadingDeleteUser}
        title={`Delete User #${userId}`}
        content={`Are you sure you want to delete user - (Name: ${userFullName}, Email: ${userEmail})? this action is not revertable.`}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
    />
    <Confirm
        isOpen={openDeleteConfirm}
        loading={isLoadingDeleteUser}
        title={`Delete User #${userId}`}
        content={`User - (Name: ${userFullName}, Email: ${userEmail}) deleted successfully, we hope to see you soon!`}
        onConfirm={logout}
        onClose={logout}
    />
    </>
    );
});

const MyAppBar = withStyles(styles)(({ classes, ...props }) => {
    const { identity, loading: identityLoading } = useGetIdentity();
    if (identityLoading) return <>Loading...</>;
return(
    <AppBar {...props} userMenu={ identity && identity.role != 'guest' ?
    <UserMenu>
        <RemoveUserWithRef className={classes.removeUser} userId={identity && identity.userId} userFullName={identity && identity.fullName} userToken={identity && identity.token} userEmail={identity && identity.email}/>
    </UserMenu> : undefined
    }>
        <Typography
            variant="title"
            color="inherit"
            className={classes.title}
            id="react-admin-title"
        />
        <img style={{width: "100px", height: "50px"}} src={logo} alt="Logo" />
        <span className={classes.spacer} />
    </AppBar>
)});

export default MyAppBar;